import './App.css';
import Home from './home.js';

function App() {
  return (
    <Home></Home>
  );
}

export default App;
